import { Constants, Events } from '../Contract';
import { Inject } from '.';
var WorkQueue = (function () {
    function WorkQueue(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject ? inject : Inject.Instance;
        this.event = this.inject.resolve(Constants.EventAggregator);
        this.queue = {};
        this.init();
    }
    WorkQueue.prototype.addToWorkQueue = function (data) {
        if (data.key && data.key !== this.executingKey) {
            this.queue[data.key] = data.fn;
        }
    };
    WorkQueue.prototype.executeWorkQueue = function () {
        for (var key in this.queue) {
            if (this.queue.hasOwnProperty(key)) {
                var fn = this.queue[key];
                if (typeof (fn) === 'function') {
                    try {
                        this.executingKey = key;
                        fn();
                    }
                    finally {
                        this.executingKey = '';
                    }
                }
                delete this.queue[key];
            }
        }
    };
    WorkQueue.prototype.init = function () {
        var _this = this;
        this.event.subscribe(Events.AddToWorkQueue, function (data) { _this.addToWorkQueue(data); });
        this.event.subscribe(Events.ExecWorkQueue, function () { _this.executeWorkQueue(); });
    };
    return WorkQueue;
}());
export { WorkQueue };
